var render = function render(){var _vm=this,_c=_vm._self._c;return _c('input',{class:!_vm.typeString || _vm.typeString.length === 0 ? 'is-empty' : '',attrs:{"type":"text","readonly":"","placeholder":"Types"},domProps:{"value":_vm.typeString},on:{"click":function($event){$event.preventDefault();return _vm.onClick.apply(null, arguments)}}})
}
var staticRenderFns = []

export { render, staticRenderFns }